import React, { useState, useEffect } from "react";
import { db, storage } from "./firebase";
import { collection, addDoc, serverTimestamp, doc, getDoc } from "firebase/firestore";
import { ref, getDownloadURL } from "firebase/storage";
import { useAuth } from "../context/AuthContext";
import "./ContactOwnerForm.css";

const ContactOwnerForm = ({ ownerId, listingId, onClose }) => {
  const { currentUser } = useAuth();
  const [message, setMessage] = useState("");
  const [username, setUsername] = useState("");
  const [customId, setCustomId] = useState("");
  const [avatarUrl, setAvatarUrl] = useState("");

  // ✅ Fetch user info + avatar
 // ✅ Fetch user info + avatar
useEffect(() => {
  if (!currentUser?.uid) return;

  const fetchUserData = async () => {
    try {
      const userDocRef = doc(db, "user-data", currentUser.uid);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        const data = userDocSnap.data();
        setUsername(data.username || "");
        setCustomId(data.customId || "");

        const avatarPath = data.avatarUrl;
        if (avatarPath && avatarPath.trim() !== "") {
          try {
            const avatarRef = ref(storage, avatarPath);
            const downloadUrl = await getDownloadURL(avatarRef);
            setAvatarUrl(downloadUrl);
          } catch (err) {
            console.error("Error fetching avatar:", err);
            setAvatarUrl("");
          }
        } else {
          setAvatarUrl("");
        }
      }
    } catch (err) {
      console.error("Error fetching user data:", err);
      setAvatarUrl("");
    }
  };

  fetchUserData();
}, [currentUser]);


  // ✅ Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentUser) return alert("Please log in to contact the owner.");
    if (!message.trim()) return alert("Please write a message.");

    const messageData = {
      listingId,
      senderId: currentUser.uid,
      senderName: username,
      senderEmail: currentUser.email,
      senderCustomId: customId,
      senderAvatar: avatarUrl,
      message: message.trim(),
      createdAt: serverTimestamp(),
      status: "new",
    };

    try {
      // ✅ Save message in Firestore (owner’s inbox + sender’s sent box)
      await addDoc(collection(db, "ownerInbox", ownerId, "messages"), messageData);
      await addDoc(collection(db, "sentMessages", currentUser.uid, "messages"), messageData);

      // ✅ Send FCM notification via your Cloud Run backend
     const response = await fetch(
  "https://us-central1-apnaghar-abb6a.cloudfunctions.net/razorpayApi/sendNotification",
  {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // no need for Bearer token here — backend already verifies via Firebase Admin
        },
        body: JSON.stringify({
          targetUserId: ownerId,
          title: `New message from ${username || "Someone"}`,
          body: message.trim(),
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("FCM send failed:", errorText);
        alert("Message saved, but notification failed to send.");
        return;
      }

      alert("✅ Message sent and owner notified!");
      setMessage("");
      onClose();
    } catch (err) {
      console.error("Error sending message or notification:", err);
      alert("❌ Failed to send message. Check Firestore rules and backend setup.");
    }
  };

  return (
    <div className="contact-modal">
      <div className="contact-box">
        <h3>Contact Owner</h3>

        <div className="avatar-preview">
          {avatarUrl ? (
            <img src={avatarUrl} alt="Your Avatar" className="avatar-image" />
          ) : (
            <div className="avatar-placeholder">No Avatar</div>
          )}
        </div>

        <form onSubmit={handleSubmit}>
          <input type="text" value={username || ""} disabled placeholder="Your Name" />
          
          <input type="text" value={customId || ""} disabled placeholder="Your ID" />
          <textarea
            placeholder="Write your message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
          <div className="form-actions">
            <button type="submit" className="send-btn">Send</button>
            <button type="button" className="cancel-btn" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactOwnerForm;
